export default __webpack_public_path__ + "static/media/money-back-guarantee.02b5fa19.png";